import { render } from "./App.vue?vue&type=template&id=333564f5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattsaravitz/Desktop/Folder/Fresh Stack Apps/Projects/Sales Talon Project/Sales Talon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__